import { AuthenticationContainer, StyledLoginFormContainer } from "../../components";

import { PasswordResetCompleteForm } from "./password-reset-complete-form";

export interface PasswordResetCompleteTemplateProps {
	readonly onSubmit: (password: string) => void;
	readonly isSubmitting: boolean;
	readonly errorMessage: string | null;
}

export const PasswordResetCompleteTemplate: React.FC<PasswordResetCompleteTemplateProps> = ({
	onSubmit,
	isSubmitting,
	errorMessage,
}) => {
	return (
		<AuthenticationContainer>
			<StyledLoginFormContainer maxWidth="sm">
				<PasswordResetCompleteForm onSubmit={onSubmit} isSubmitting={isSubmitting} errorMessage={errorMessage} />
			</StyledLoginFormContainer>
		</AuthenticationContainer>
	);
};
